import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useApp } from "@/context/AppContext";

const inputCls = "bg-[#F5F0E6] border-[#D8CFBB] text-[#1A1610] focus-visible:ring-[#C5A880]";
const readOnlyCls = "bg-[#EBE3D3]/40 border-[#D8CFBB] text-[#4A3F30] font-mono text-xs";

export default function NDNCAPartiesSection({ tpl, form, setForm, userEmail }) {
  const { lang } = useApp();
  return (
    <>
      <div className="rounded-md border border-[#C5A880]/40 bg-[#F0E7D3] p-4">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-2">
          {lang === "it" ? "La Piattaforma" : "The Platform"}
        </p>
        <p className="text-sm font-medium">{tpl?.platform?.name || "AARON & PARTNERS S.R.L."}</p>
        <p className="text-xs text-[#4A3F30]">P.IVA {tpl?.platform?.vat} · REA {tpl?.platform?.rea}</p>
        <p className="text-xs text-[#4A3F30]">{tpl?.platform?.address}</p>
        <p className="text-xs text-[#4A3F30]">PEC: {tpl?.platform?.pec}</p>
        <p className="text-xs text-[#6B5F4C] mt-1 italic">{tpl?.platform?.admin}</p>
      </div>

      <div>
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-3">
          {lang === "it" ? "Il Membro (i tuoi dati)" : "The Member (your data)"}
        </p>
        <div className="grid gap-3">
          <div>
            <Label className="text-[#4A3F30]">
              {lang === "it" ? "Nome e cognome / Ragione sociale" : "Full name / Company"}
            </Label>
            <Input
              data-testid="ndnca-name"
              className={inputCls}
              value={form.signer_name}
              onChange={(e) => setForm({ ...form, signer_name: e.target.value })}
            />
          </div>
          <div>
            <Label className="text-[#4A3F30]">
              {lang === "it" ? "Codice fiscale / P.IVA" : "Fiscal code / VAT"}
            </Label>
            <Input
              data-testid="ndnca-fiscal"
              className={inputCls}
              value={form.signer_fiscal_code}
              onChange={(e) => setForm({ ...form, signer_fiscal_code: e.target.value })}
            />
          </div>
          <div>
            <Label className="text-[#4A3F30]">{lang === "it" ? "Indirizzo" : "Address"}</Label>
            <Input
              data-testid="ndnca-address"
              className={inputCls}
              value={form.signer_address}
              onChange={(e) => setForm({ ...form, signer_address: e.target.value })}
            />
          </div>
          <div>
            <Label className="text-[#4A3F30]">Email</Label>
            <Input readOnly className={readOnlyCls} value={userEmail || ""} />
          </div>
        </div>
      </div>

      <div className="rounded-md border border-[#D8CFBB] bg-[#F5F0E6] p-3 text-xs text-[#4A3F30] leading-relaxed">
        <p className="uppercase tracking-widest text-[#C5A880] text-[10px] mb-2">
          {lang === "it" ? "Clausole principali" : "Main clauses"}
        </p>
        <ul className="list-disc ps-5 space-y-1">
          {(tpl?.clauses_summary || []).map((c) => <li key={c}>{c}</li>)}
        </ul>
      </div>
    </>
  );
}
